import { Box } from "@mui/material";
import { HRService } from "../../../../config";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import PracticeGroupForm from "./form";
import { allPracticeGroups } from "../../../../data/Queries/HRmanagement/leavemanagement"; // add your actual query path if different

const base_url = HRService.uri;

const actions = {
  entity: "Practice Group",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  showStatus: true,
};

const PracticeGroupColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "name", headerName: "Practice Group Name", flex: 1 },
  { field: "createdBy", headerName: "Created By", flex: 0.8 },
  { field: "createdDate", headerName: "Created Date", flex: 1 },
  { field: "updatedBy", headerName: "Updated By", flex: 0.8 },
  { field: "updatedDate", headerName: "Updated Date", flex: 1 },
];

function PracticeGroupTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Practice Groups"
        subtitle="View, create and edit practice groups."
        columns={PracticeGroupColumns}
        FormComponent={PracticeGroupForm}
        actions={actions}
        query={allPracticeGroups}
        base_url={base_url}
      />
    </Box>
  );
}

export default PracticeGroupTable;
